import { getRuntimeConfig } from '@/pages/api/config';

export default {
  get: (key: Parameters<typeof getRuntimeConfig>[0], defaultValue?: any) =>
    getRuntimeConfig(key) || defaultValue,
};
